import * as React from "react";
import styled from "styled-components";
import classNames from 'classnames';
import logo from '../resources/youth_gps_logo.svg';
import Boy from '../resources/boy.svg';
import Girl from '../resources/girl.svg';
import BarChartComp from "../Charts/BarChart";
import PieChartComponent from "../Charts/PieChart";
import BACGaugeChart from "../Charts/BACGaugeChart";
import YouthBg from '../resources/youth_bg.svg';
import BarChartHorizontalComp from "../Charts/BarChartHorizontal";
import { ButtonWrap as BaseButtonWrap, Button } from "./MIView1";
import RightArrow from '../resources/right-arrow.svg';
import QuoteLeft from '../resources/quote-left.svg';
import QuoteRight from '../resources/quote-right.svg';
import Car from '../resources/response_car.svg';
import VapeWarning from '../resources/vape-warning.svg';
import VapeTips from '../resources/vape-tips.svg';
import MarijuanaBoy from '../resources/marijuana-boy.svg';
import MarijuanaWarning from '../resources/marijuana-warning.svg';
import AlcoholTipText from '../resources/alcohol-tip-text.svg';
import BingeTipText from '../resources/binge-tip-text.svg';
import AlcoholWarning from '../resources/alcohol-warning.svg';
import NumberOfDrinksWarning from '../resources/drinks-warning.svg';
import HeavyDrinkingWarning from "../resources/standard_drink_advice.svg";
import BACWarning from '../resources/bac-warning.svg';
import { useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf'; 
import downloadImg from '../resources/Download.png';
import TobaccoTipText from '../resources/tobacco_tip_text.svg';
import QuantityTipText from '../resources/quantity-tip-text.svg'
import Loader from '../components/Loader';
import { createGlobalStyle } from "styled-components";

const MIMetrics1 = () => {
  const history = useNavigate();
  let [loading, setLoading] = React.useState(true);
  let studentResponses = JSON.parse(sessionStorage.getItem("MI1Metrics"));
  let PARTID = sessionStorage.getItem("PARTID");
  let [vapeData , setVapeData] = React.useState([]);
  let [marijuanaData , setMarijuanaData] = React.useState([]);
  let [alcoholData , setAlcoholData] = React.useState([]);
  let [alcoholBingeData , setAlcoholBingeData] = React.useState([]);
  let [alcoholQuantityData , setAlcoholQuantityData] = React.useState([]);
  let [sampleMetrics1Data , setSampleMetrics1Data] = React.useState({});
  let [auditScore, setAuditScore] = React.useState(0);
  let [audit, setAudit] = React.useState("");
  let [sampleData, setSampleData] = React.useState({});
  // console.log("student responses",studentResponses)

  React.useEffect(() => {
    // console.log(sessionStorage.getItem('logged_in'))
    const timeout = setTimeout(() => {
        if(!sessionStorage.getItem('logged_in') || parseInt(sessionStorage.getItem('mi_metrics1_submitted')) != 1){
            history('/');
        } else {
          
          setSampleData({
            "statusCode": 200,
            "body": {
              "metrics": {
                "ANYTOB30D": studentResponses['ANYTOB30D'],
                "VAP30D": studentResponses['VAP30D'],
                "show_vape_comparision": studentResponses['show_vape_comparision'],
                "MJ30D": studentResponses['MJ30D'],
                "show_mj_comparision": studentResponses['show_mj_comparision'],
                "ALC30D": studentResponses['ALC30D'],
                "show_alc_comparision": studentResponses['show_alc_comparision'],
                "show_drinker_pop_avg": studentResponses['show_drinker_pop_avg'],
                "ALOCHOL_QUANTITY": studentResponses['ALOCHOL_QUANTITY'],
                "show_alcohol_quantity_comparision": studentResponses['show_alcohol_quantity_comparision'],
                "show_drinker_pop_avg_alcohol_quantity": studentResponses['show_drinker_pop_avg_alcohol_quantity'],
                "BINGE530D": studentResponses['BINGE530D'],
                "show_binge_comparision": studentResponses['show_binge_comparision'],
                "show_drinker_pop_avg_binge": studentResponses['show_drinker_pop_avg_binge'],
                "BAC": parseFloat(studentResponses['BAC'].toFixed(2)),
                "show_bac_comparision": 
                studentResponses['show_bac_comparision'] === true || 
                studentResponses['show_bac_comparision'] === 1 || 
                studentResponses['show_bac_comparision'] === "1" || 
                studentResponses['show_bac_comparision'] === "true",
               
                "audit_score": studentResponses['audit_score'] ? studentResponses['audit_score'] : 0,
                "heaviest_bac": parseFloat(studentResponses['HEAVIEST_BAC'].toFixed(2)),
                },
              "student_id": PARTID
            }
          });
          setSampleMetrics1Data({
            "ANYTOB30D": studentResponses['ANYTOB30D'],
            "VAP30D": studentResponses['VAP30D'],
            "show_vape_comparision": studentResponses['show_vape_comparision'],
            "MJ30D": studentResponses['MJ30D'],
            "show_mj_comparision": studentResponses['show_mj_comparision'],
            "ALC30D": studentResponses['ALC30D'],
            "show_alc_comparision": studentResponses['show_alc_comparision'],
            "show_drinker_pop_avg": studentResponses['show_drinker_pop_avg'],
            "ALOCHOL_QUANTITY": studentResponses['ALOCHOL_QUANTITY'],
            "show_alcohol_quantity_comparision": studentResponses['show_alcohol_quantity_comparision'],
            "show_drinker_pop_avg_alcohol_quantity": studentResponses['show_drinker_pop_avg_alcohol_quantity'],
            "BINGE530D": studentResponses['BINGE530D'],
            "show_binge_comparision": studentResponses['show_binge_comparision'],
            "show_drinker_pop_avg_binge": studentResponses['show_drinker_pop_avg_binge'],
            "BAC": parseFloat(studentResponses['BAC'].toFixed(2)),
            "show_bac_comparision": 
   studentResponses['show_bac_comparision'] === true || 
   studentResponses['show_bac_comparision'] === 1 || 
   studentResponses['show_bac_comparision'] === "1" || 
   studentResponses['show_bac_comparision'] === "true",

            "audit_score": studentResponses['audit_score'] ? studentResponses['audit_score'] : 0,
            "heaviest_bac": parseFloat(studentResponses['HEAVIEST_BAC'].toFixed(2)),
            });
          setVapeData([
            {
              name: 'You',
              value: studentResponses.VAP30D || 0,
            },
            {
              name: 'People your age Avg for past 30 days',
              value: 9,
            }
          ]);

          setMarijuanaData([
            {
              name: 'You',
              value: studentResponses.MJ30D,
            },
            {
              name: 'People your age who use marijuana, on average',
              value: 4,
            }
          ]);
          setAlcoholData([
            {
              name: 'You',
              value: studentResponses.ALC30D || 0,
            },
            {
              name: 'Avg',
              value: 4,
            }
          ]);
          
          setAlcoholBingeData([
            {
              name: 'You',
              value: studentResponses.BINGE530D,
            },
            {
              name: 'Avg',
              value: 1.7,
            }
          ]);
          
          setAlcoholQuantityData([
            {
              name: 'You',
              value: studentResponses.ALOCHOL_QUANTITY,
            },
            {
              name: 'Avg',
              value: 3.5,
            }
          ]);
          setAuditScore(studentResponses.audit_score);
          setLoading(false);

        }
    }, 1000);

    // Clean-up function to clear the timeout when the component unmounts
    return () => clearTimeout(timeout);
    
  }, []);

  // console.log("sampleData", sampleData);
  const downloadPage = async () => {
    setIsDownloading(true);
    await document.fonts.ready;
  
    const source = document.getElementById('metrics1');
    if (!source) {
      setIsDownloading(false);
      return;
    }
  
    // ---- 1) make an off-screen desktop clone ----
    const DESKTOP_W = 1470; // use your desktop value (you measured 1470)
    const clone = source.cloneNode(true);
    clone.id = 'metrics1-pdf-clone';
    Object.assign(clone.style, {
      width: `${DESKTOP_W}px`,
      maxWidth: 'none',
      height: 'auto',
      position: 'fixed',
      left: '-10000px',
      top: '0',
      zIndex: '-1',
      transform: 'none',
      overflow: 'visible',
      background: '#ffffff'
    });
    document.body.appendChild(clone);
  
    // ---- 2) Wait for charts to render ----
    await new Promise(resolve => setTimeout(resolve, 1000));

    // ---- 3) make sure images in the CLONE are ready ----
    const imgs = Array.from(clone.querySelectorAll('img'));
    try {
      await Promise.all(
        imgs.map(img =>
          // Safari sometimes lacks decode(); fall back to onload/complete
          img.decode ? img.decode() : (img.complete ? Promise.resolve() : new Promise(res => img.onload = res))
        )
      );
    } catch (_) {}

    // ---- 4) compute safe scale for iOS (avoid > ~16384 px canvas) ----
    const targetWidth = DESKTOP_W;
    // Add more padding for mobile devices to prevent cuts
    const isMobile = window.innerWidth <= 768;
    const extraPadding = isMobile ? 200 : 100;
    const targetHeight = clone.scrollHeight + extraPadding;
    const MAX_CANVAS = 16000;                         // conservative
    let scale = Math.min(window.devicePixelRatio || 1, 2);
    const worstSide = Math.max(targetWidth, targetHeight);
    if (worstSide * scale > MAX_CANVAS) {
      scale = Math.max(1, (MAX_CANVAS - 1) / worstSide); // keep under cap
    }
  
    // ---- 5) render the CLONE (not the live DOM) ----
    const canvas = await html2canvas(clone, {
      scale,
      useCORS: true,
      backgroundColor: '#ffffff',
      // Force desktop media queries and full height
      windowWidth: targetWidth,
      windowHeight: targetHeight,
      scrollX: 0,
      scrollY: 0,
      logging: false,
      removeContainer: true
    });
  
    // Clean up the clone
    document.body.removeChild(clone);
  
    // ---- 6) build one long-page PDF (no page breaks) ----
    const imgData = canvas.toDataURL('image/jpeg', 0.95);
    const pdfProbe = new jsPDF('p', 'mm', 'a4');
    const pdfW = pdfProbe.internal.pageSize.getWidth();
    const props = pdfProbe.getImageProperties(imgData);
    const pdfH = (props.height * pdfW) / props.width;
  
    const longPdf = new jsPDF('p', 'mm', [pdfW, pdfH]);
    longPdf.addImage(imgData, 'JPEG', 0, 0, pdfW, pdfH);
    const today = new Date();
    const dateStr = today.toISOString().split('T')[0]; // "2025-09-22"

    longPdf.save(`MIMetrics1_${PARTID}_${dateStr}.pdf`);

    
  
    setIsDownloading(false);
  };
  
  const [isDownloading, setIsDownloading] = React.useState(false);

  const DonutChartData = [
      { name: 'Low Risk', value: 100, range: "0-3", color: "#0088FE",
      message: "Someone using alcohol at this level is at low risk for health or social complications." },
      { name: 'Risky', value: 100, range: "4-9", color: "#00C49F", message: "Someone using alcoholat this level may develop health problems or existing problems may worsen." },
      { name: 'Harmful', value: 100, range: "10-13", color: "#FFBB28", message: "Someone using alcohol at this level could benefit from more assessment and assistance" },
      { name: 'Severe', value: 100, range: "14+", color: "#FF8042", message: "Someone using alcohol at this level has experienced negative effects from alcohol use." },
    ];

  
  const getAuditMessage = () => {
    // console.log(auditScore)
    if(auditScore >= 0 && auditScore <= 3){
      audit = "Low Risk";
    }
    else if(auditScore >= 4 && auditScore <= 9){
      audit = "Risky";
    }
    else if(auditScore >= 10 && auditScore <= 13){
      audit = "Harmful";
    }
    else{
      audit = "Severe";
    }
  };

  if (!auditScore) {
    auditScore = 0;
  } 


  getAuditMessage(auditScore);

  const onSectionChange = () => {
    sessionStorage.setItem("selectedPageIndex", 0);
    sessionStorage.setItem("MI1_submitted", 1);
    history('/MI2');
  }
  const InsertPDFSpace = ({ height }) =>
  isDownloading ? <div style={{ height }} /> : null;


  return(
    loading ? <div>
        <Loader />
    </div> :
    
      
    <MetricsWrap>        
      <Heading className="metrics-title">
        <img src={logo} />
        <h2 style={{marginTop: '20px'}}>Metrics</h2>
      </Heading>
      
      <BackgroundWrap>
      {!isDownloading ? <button onClick={downloadPage} style={{color: 'blue', margin: '20px 7.5% 20px auto', display: 'flex', flexDirection: 'row', border: 'none', background:'none'}}>
        <p style={{margin: 'auto', padding: '5px'}}>Download</p>
        <img style={{marginLeft: '5px'}} width='30px' height='30px' src={downloadImg}></img>
      </button> : false}
      <InsertPDFSpace height="0px" />
      
      <ContentWrap id="metrics1">
          <Top>
          <ResponsesText>
          <p>STRAIGHT AHEAD,</p>
          <p>YOU'LL FIND YOUR RESPONSES!</p>
          </ResponsesText>
          <img width={"100%"} src={Car} />
          </Top>  
          <Content>
                {studentResponses.ANYTOB30D !== 0 &&
                <ContentBox>
            <HeadingText>
                <h3>TOBACCO</h3>
                <h4>POPULATION STATS AND YOU</h4>
              </HeadingText>
              <img className="quote" src={QuoteLeft} />
              <span>In the past 30 days, you said you used tobacco on:</span>
              <DaysText>{studentResponses.ANYTOB30D}</DaysText> days
              <img className="quote" src={QuoteRight} />
              <TobaccoTipWrap>
              {/* <img className="tobbaco-tip" src={TobaccoStatsImg} width={"100%"} />
              <div>On average, 16.2% of your peers reported using tobacco at least once in the past 30 days, and 25.3% of them reported using tobacco in the past year.</div> */}
              <img className="tobacco-tip" src={TobaccoTipText} width={"100%"} />
              </TobaccoTipWrap>
            </ContentBox>}
              
            {/* === VAPING (ALWAYS SHOW CHART) === */}
            {studentResponses.VAP30D > 9 && (
            <ContentBox>
              <HeadingText>
                <h3>VAPING</h3>
                <h4>POPULATION STATS AND YOU</h4>
              </HeadingText>
              <img className="quote" src={QuoteLeft} />
              <span>In the past 30 days, you said you vaped on:</span>
              <DaysText>{studentResponses.VAP30D}</DaysText> days
              <img className="quote" src={QuoteRight} />

              {sampleMetrics1Data['show_vape_comparision'] == 1 && (
                <>
                  <p>On average, 23.5% of your peers reported vaping at least once in the past 30 days, and 33% of them reported vaping in the past year.</p>
                </>
              )}

              <BarWrap style={{justifyContent: "center"}}>
                <Box>
                  <BarCompWrap width={600}>
                    <BarChartComp
                      barChartData={vapeData} 
                      bar1Key="value" 
                      label="Vape Use" 
                      layout="vertical"
                      barWidth={30}
                    />
                  </BarCompWrap>
                  <h3>PAST MONTH USE - NUMBER OF DAYS</h3>
                </Box>
              </BarWrap>


              <ImagesWrap>
                <img src={VapeWarning} width={"100%"} />
                <img src={VapeTips} width={"100%"} />
              </ImagesWrap>
            </ContentBox>
            )}
            {/* === END VAPING === */}

            <InsertPDFSpace height="0px" />

            {/* === MARIJUANA (ALWAYS SHOW CHART) === */}
            {studentResponses.MJ30D > 4 && (
            <ContentBox>  
              <HeadingText>
                <h3>MARIJUANA</h3>
                <h4>POPULATION STATS AND YOU</h4>
              </HeadingText>
              <img className="quote" src={QuoteLeft} />
              <span>In the past 30 days, you said you used marijuana on:</span>
              <DaysText>{studentResponses['MJ30D']}</DaysText>  days
              <img className="quote" src={QuoteRight} />
              <img src={MarijuanaBoy} width={"100%"} />

              {sampleMetrics1Data['show_mj_comparision'] !== 0 && (
                <>
                  <p>
                    On average, 24% of your peers reported using marijuana at least once in the past 30 days, and 34.1% of them reported vaping in the past year.
                    <img className="quote" src={QuoteRight} width={50} height={50} />
                  </p>
                </>
              )}

              <BarWrap style={{justifyContent: "center"}}>
                <Box>
                  <BarCompWrap width={600}>
                  <BarChartComp
  barChartData={marijuanaData} 
  bar1Key="value" 
  label="Marijuana Use" 
  layout="vertical"
  leftMargin={80}
  barWidth={30}
/>

                  </BarCompWrap>
                  <h3>PAST MONTH USE - NUMBER OF DAYS</h3>
                </Box>
              </BarWrap>

              <ImagesWrap>
                <img src={MarijuanaWarning} width={"100%"} />
              </ImagesWrap>
            </ContentBox>
            )}
            {/* === END MARIJUANA === */}

            {/* === ALCOHOL DAYS (ALWAYS SHOW CHART) === */}
            {studentResponses.ALC30D > 4 && (

            <ContentBox>
              <HeadingWrap>
                <HeadingText>
                  <h3>ALCOHOL</h3>
                  <h4>POPULATION STATS AND YOU</h4>
                </HeadingText>
              </HeadingWrap>
              <VapeSectionWrap>
                <AlcoholTipWrap>
                  <>
                    <img className="quote" src={QuoteLeft} width={40} height={40} />
                    <span>In the past 30 days, you said you had alcohol on:</span>
                    <DaysText>{studentResponses.ALC30D}</DaysText> days
                    <img className="quote" src={QuoteRight} width={40} height={40} />
                  </>
                  {sampleMetrics1Data.show_alc_comparision !== 0 && (
                    <img className="alcohol-tip" src={AlcoholTipText} />
                  )}
                </AlcoholTipWrap>

                <Box>
                  <h3>PAST MONTH USE - NUMBER OF DAYS</h3>
                  <BarCompHorizontalWrap>
                    <BarChartHorizontalComp
                      barChartData={alcoholData} 
                      bar1Key="value" 
                      label="Drinking Days" 
                      barWidth={30}
                    />
                  </BarCompHorizontalWrap>
                </Box>
              </VapeSectionWrap>

              <MiniScreenWrap>
                <AlcoholTipWrap>
                  <>
                    <img className="quote" src={QuoteLeft} />
                    <span>In the past 30 days, you said you had alcohol on:</span>
                    <DaysText>{studentResponses.ALC30D}</DaysText> days
                    <img className="quote" src={QuoteRight} />
                  </>
                  {sampleMetrics1Data.show_alc_comparision !== 0 && (
                    <img className="alcohol-tip" src={AlcoholTipText} />
                  )}
                </AlcoholTipWrap>

                <Box style={{padding: "2% 0 0"}}>
                  <h3>PAST MONTH USE - NUMBER OF DAYS</h3>
                  <BarCompHorizontalWrap>
                    <BarChartHorizontalComp
                      barChartData={alcoholData} 
                      bar1Key="value" 
                      label="Drinking Days" 
                      barWidth={30}
                    />
                  </BarCompHorizontalWrap>
                </Box>
              </MiniScreenWrap>

              <ImagesWrap>
                <img src={AlcoholWarning} width={"100%"} />
              </ImagesWrap>
            </ContentBox>
            )}
            {/* === END ALCOHOL DAYS === */}

<ContentBox>
            <HeadingWrap>
              <TipsHeading>
                STUFF ABOUT ALCOHOL AND YOU
                </TipsHeading>
                </HeadingWrap>
              <section>
                <h4>Alcohol and Your Body</h4>
                <p>The immediate effects of alcohol can include slurred speech, blurred vision, changes in mood, loss of inhibitions, vomiting, loss of balance, and clumsiness.</p>
                <p>These effects are greater with increasing amounts of alcohol consumed. The more we drink, the stronger the ‘slowing down’ effects of alcohol will be, which is why it's called a depressant. With more consumption, there are more serious effects such as nausea and vomiting, loss of consciousness, blackouts, and even coma or death.</p>
                <p>Longer-term effects of heavy drinking can leave you with serious health problems. These can include alcohol dependence, liver damage or disease, mood changes, cancer (mouth, throat, breast), sexual difficulties, memory loss, or strokes.</p>                
                </section>
            </ContentBox>

            {/* === BINGE (ALWAYS SHOW CHART) === */}
            {studentResponses.BINGE530D > 1.7 && (
            <ContentBox>
              <HeadingWrap>
                <HeadingText>
                  <h3>HEAVY DRINKING</h3>
                  <h4>POPULATION STATS AND YOU</h4>
                </HeadingText>
              </HeadingWrap>
              <VapeSectionWrap>
                {sampleMetrics1Data.show_binge_comparision !== 0 && (
                  <BingeTipSection>
                    <img className="binge-tip" src={BingeTipText} />
                  </BingeTipSection>
                )}

                <Box>
                  <h3>PAST MONTH - NUMBER OF BINGE DAYS</h3>
                  <BarCompHorizontalWrap width={500}>
                    <BarChartHorizontalComp
                      barChartData={alcoholBingeData} 
                      bar1Key="value" 
                      label="Binge Drinking" 
                      barWidth={30}
                    />
                  </BarCompHorizontalWrap>
                </Box>
              </VapeSectionWrap>

              <MiniScreenWrap>
                <Box style={{padding: "2% 0 0"}}>
                  <h3>PAST MONTH - NUMBER OF BINGE DAYS</h3>
                  <BarCompHorizontalWrap width={500}>
                    <BarChartHorizontalComp
                      barChartData={alcoholBingeData} 
                      bar1Key="value" 
                      label="Binge Drinking" 
                      barWidth={30}
                    />
                  </BarCompHorizontalWrap>
                </Box>
                {sampleMetrics1Data.show_binge_comparision !== 0 && (
                  <BingeTipSection>
                    <img className="binge-tip" src={BingeTipText} />
                  </BingeTipSection>
                )}
              </MiniScreenWrap>

              <ImagesWrap>
                <img src={NumberOfDrinksWarning} width={"100%"} />
              </ImagesWrap>
            </ContentBox>
            )}
            {/* === END BINGE === */}
              
            {/* === DRINKS PER OCCASION (ALWAYS SHOW CHART) === */}
            {studentResponses.ALOCHOL_QUANTITY > 3.5 && (
            <ContentBox>
              <HeadingWrap>
                <HeadingText>
                  <h3>NUMBER OF DRINKS</h3>
                  <h4>POPULATION STATS AND YOU</h4>
                </HeadingText>
              </HeadingWrap>

              <VapeSectionWrap>
                <Box>
                  <h3>PAST MONTH - NUMBER OF DRINKS</h3>
                  <BarCompHorizontalWrap  width={500}>
                    <BarChartHorizontalComp
                      barChartData={alcoholQuantityData} 
                      bar1Key="value" 
                      label="Drinks per occasion" 
                      barWidth={30}
                    />
                  </BarCompHorizontalWrap>
                </Box>

                {sampleMetrics1Data.show_alcohol_quantity_comparision !== 0 && (
                  <DrinksTipWrap>
                    <img className="drink-tip" src={QuantityTipText} />
                  </DrinksTipWrap>
                )}
              </VapeSectionWrap>

              <InsertPDFSpace height="0px" />

              <MiniScreenWrap>
                <Box style={{padding: "2% 0 0"}}>
                  <h3>PAST MONTH - NUMBER OF DRINKS</h3>
                  <BarCompHorizontalWrap height={200}>
                    <BarChartHorizontalComp
                      barChartData={alcoholQuantityData} 
                      bar1Key="value" 
                      label="Drinks per occasion"
                      peerLabel="People your age who drink, on average"
                      barWidth={30}
                    />
                  </BarCompHorizontalWrap>
                </Box>

                {sampleMetrics1Data.show_alcohol_quantity_comparision !== 0 && (
                  <DrinksTipWrap>
                    <img className="drink-tip" src={QuantityTipText} width={"100%"} />
                  </DrinksTipWrap>
                )}
              </MiniScreenWrap>

              <ImagesWrap>
  <img src={HeavyDrinkingWarning} className="tip-img" alt="Standard Drink Advice" />
</ImagesWrap>


            </ContentBox>
            )}
            {/* === END DRINKS PER OCCASION === */}


            {studentResponses.show_bac_comparision && (
            <ContentBox>
              <HeadingWrap>
              <HeadingText width="fit-content">
                <h3>BLOOD ALCOHOL CONTENT (BAC)</h3>
                <h4>POPULATION STATS AND YOU</h4>
              </HeadingText>
              </HeadingWrap>
              <VapeSectionWrap style={{marginTop: "30px", flexDirection: "column", alignItems: "center"}}>
                {/* 1. Survey Text */}
                <BACTipWrap style={{width: "100%", textAlign: "center", marginBottom: "20px"}}>
                  {sampleMetrics1Data.show_bac_comparision !== 0 && 
                  <p>
                    Based on your survey responses, your average estimated blood alcohol content, or BAC, is <strong>{sampleData.body.metrics.BAC}%</strong>, and for your heaviest drinking occasion, your estimated blood alcohol content is <strong>{sampleData.body.metrics.heaviest_bac}%</strong>.
                  </p>
                  }
                </BACTipWrap>

                {/* 2. BAC Chart */}
                <div style={{width: "100%", display: "flex", justifyContent: "center", marginBottom: "10px"}}>
                  <BACGaugeChart value={studentResponses.HEAVIEST_BAC} />
                </div>

                {/* 2.5. Past 30 Days Heading */}
                <h2 style={{textAlign: "center", marginBottom: "20px"}}>Past 30 Days - Your Highest BAC</h2>

                {/* 3. BACs of People Your Age */}
                <div style={{width: "100%", textAlign: "center", marginBottom: "20px"}}>
                  <h3>BACs OF PEOPLE YOUR AGE WHO DRINK</h3>
                  <BACPopData>
                    <MaleData>
                      <img width={"70%"} src={Boy} /> 
                      <p><span>AVG</span><span style={{color: "#f1646c"}}>0.03</span></p>
                      <p><span>PEAK</span><span style={{color: "#f1646c"}}>0.09</span></p>
                    </MaleData>
                    <FemaleData>
                      <img width={"70%"} src={Girl} />
                      <p><span>AVG</span><span style={{color: "#f1646c"}}>0.04</span></p>
                      <p><span>PEAK</span><span style={{color: "#f1646c"}}>0.10</span></p>
                    </FemaleData>
                  </BACPopData>
                </div>

                {/* 4. How to Designate a Driver - Medium Size */}
                <div style={{width: "100%", textAlign: "center", maxWidth: "600px", margin: "0 auto", paddingBottom: "20px"}}>
                  <img width={"100%"} src={BACWarning} />
                </div>
              </VapeSectionWrap>
              <MiniScreenWrap>
                {/* 1. Survey Text */}
                <BACTipWrap style={{width: "100%", textAlign: "center", marginBottom: "20px"}}>
                  {sampleMetrics1Data.show_bac_comparision && 
                  <p>
                    Based on your survey responses, your average estimated blood alcohol content, or BAC, is <strong>{sampleData.body.metrics.BAC}%</strong>, and for your heaviest drinking occasion, your estimated blood alcohol content is <strong>{sampleData.body.metrics.heaviest_bac}%</strong>.
                  </p>
                  }
                </BACTipWrap>

                {/* 2. BAC Chart */}
                <div style={{width: "100%", display: "flex", justifyContent: "center", marginBottom: "10px"}}>
                  <BACGaugeChart value={studentResponses.HEAVIEST_BAC} />
                </div>

                {/* 2.5. Past 30 Days Heading */}
                <h2 style={{textAlign: "center", marginBottom: "20px"}}>Past 30 Days - Your Highest BAC</h2>

                {/* 3. BACs of People Your Age */}
                <div style={{width: "100%", textAlign: "center", marginBottom: "20px"}}>
                  <h3>BACs OF PEOPLE YOUR AGE WHO DRINK</h3>
                  <BACPopData>
                    <MaleData>
                      <img width={"70%"} src={Boy} /> 
                      <p><span>AVG</span><span style={{color: "#f1646c"}}>0.03</span></p>
                      <p><span>PEAK</span><span style={{color: "#f1646c"}}>0.09</span></p>
                    </MaleData>
                    <FemaleData>
                      <img width={"70%"} src={Girl} />
                      <p><span>AVG</span><span style={{color: "#f1646c"}}>0.04</span></p>
                      <p><span>PEAK</span><span style={{color: "#f1646c"}}>0.10</span></p>
                    </FemaleData>
                  </BACPopData>
                </div>

                {/* 4. How to Designate a Driver - Medium Size */}
                <div style={{width: "100%", textAlign: "center", maxWidth: "600px", margin: "0 auto", paddingBottom: "20px"}}>
                  <img width={"100%"} src={BACWarning} />
                </div>
              </MiniScreenWrap>
            </ContentBox>
            )}
            

            <ContentBox>
            <HeadingWrap>
              <TipsHeading>
                STUFF ABOUT ALCOHOL AND YOU
                </TipsHeading>
                </HeadingWrap>
              <section>
                <h4>Driving Under the Influence (DUI)</h4>
                <p>DUI is taken very seriously. Here are the BAC limits for drivers of different ages and the hefty punishments that may result if you decide to take the risk:</p>
                <ul>
                  <li>Drivers under the age of 21 - Your BAC limit for driving is 0.02%</li>
                  <li>Other drivers - Your BAC limit is 0.08%</li>
                  <li>If you are found to have driven under the influence, for a first offense you could get a fine between $500-$2000, plus administrative and potentially lawyer's fees. Even the first offense could lead to a sentence of 6-9 months in jail or an alcohol/drug treatment program plus probation, 50 hours or more of mandatory community service, and leave you without a license for 6 months-1 year. Subsequent offenses and DUIs where bodily harm is involved increase the amount of fines and increase the likelihood of actual jail time rather than community service only.</li>
                </ul>
                <p>Drinking alcohol can be part of an enjoyable night out, but drinking safely will ensure you have good memories and that you keep your license.</p>
                </section>
            </ContentBox>
            <InsertPDFSpace height="0px" />
            <ContentBox>
              <HeadingWrap>
              <HeadingText width="fit-content">
                <h3>ALCOHOL SCREENING (AUDIT)</h3>
              </HeadingText>
              </HeadingWrap>
              <VapeSectionWrap>
                <AuditWrap>
                <PieChartWrap>
              <PieChartComponent selected={audit} score={studentResponses.audit_score} />
              </PieChartWrap>
              <Legend>
                {DonutChartData.map((i, index) => {
                  return(
                    <AuditTypes> 
                    <Round style={{backgroundColor: audit === i.name ? i.color : "#fafafa" }}
                      />
                    <RectangleAuditBox
                    style={{backgroundColor: audit === i.name ? i.color : "#fafafa" }}
                    className= {classNames({
                      'selected-text': audit === i.name
                    })}>
                      <h4 
                      className='audit-number'
                        style={{color: i.color}}>{i.range}</h4>
                      <h4 className='audit-text'>{i.name}</h4>
                    </RectangleAuditBox>
                    </AuditTypes>
                  )
                })}
              </Legend>  
              </AuditWrap>
              <section>
              <AuditContent>
                <h3>Based on your responses, your AUDIT score is</h3>
                <div className="audit-score-wrap">
                  <span className="auditScore" style={{color: DonutChartData.find((i) => i.name === audit)?.color}}>{studentResponses.audit_score}</span>
                  </div>
                <section className="categoryText">
                {/* <h4>You fall into the</h4>
                <h4 style={{color: DonutChartData.find((i) => i.name === audit)?.color}}>{DonutChartData.find((i) => i.name === audit)?.range} {audit} Range</h4> */}
                <p>Someone using alcohol at this level could benefit from more assessment and assistance.</p>
                </section>
                {/* <p>A person scoring in this range may be alcohol dependent and advised to have a clinical assessment of their drinking.</p> */}
                {/* <p>{DonutChartData.find((i) => i.name === audit)?.message}</p> */}
              </AuditContent>
              </section>
              </VapeSectionWrap>
              <MiniScreenWrap>
              <AuditWrap>
                <PieChartWrap>
              <PieChartComponent selected={audit} score={studentResponses.audit_score} />
              </PieChartWrap>
              <Legend>
                {DonutChartData.map((i, index) => {
                  return(
                    <AuditTypes> 
                    <Round style={{backgroundColor: audit === i.name ? i.color : "#fafafa" }}
                      />
                    <RectangleAuditBox
                    style={{backgroundColor: audit === i.name ? i.color : "#fafafa" }}
                    className= {classNames({
                      'selected-text': audit === i.name
                    })}>
                      <h4 
                      className='audit-number'
                        style={{color: i.color}}>{i.range}</h4>
                      <h4 className='audit-text'>{i.name}</h4>
                    </RectangleAuditBox>
                    </AuditTypes>
                  )
                })}
              </Legend>  
              </AuditWrap>
              <section>
              <AuditContent>
                <h3>Based on your responses, your AUDIT score is</h3>
                <div className="audit-score-wrap">
                  <span className="auditScore" style={{color: DonutChartData.find((i) => i.name === audit)?.color}}>{studentResponses.audit_score}</span>
                  </div>
                <section className="categoryText">
                {/* <h4>You fall into the</h4>
                <h4 style={{color: DonutChartData.find((i) => i.name === audit)?.color}}>{DonutChartData.find((i) => i.name === audit)?.range} {audit} Range</h4> */}
                <p>Someone using alcohol at this level could benefit from more assessment and assistance.</p>
                </section>
                {/* <p>A person scoring in this range may be alcohol dependent and advised to have a clinical assessment of their drinking.</p> */}
                {/* <p>{DonutChartData.find((i) => i.name === audit)?.message}</p> */}
              </AuditContent>
              </section>
              </MiniScreenWrap>
              {/* <img src={TobaccoStatsImg} width={"95%"} /> */}
            </ContentBox>

            <ContentBox>
            <HeadingWrap>
              <TipsHeading>
                STUFF ABOUT ALCOHOL AND YOU
                </TipsHeading>
                </HeadingWrap>
              <section>
                <h4>Other Effects of Alcohol</h4>
                <p>Alcohol can affect more than just your body. There are physical and social risks that may happen when drinking too much. These can include injury, car crashes, getting into trouble with the police, arguments, fights, unwanted or unsafe sexual activity, offending others or doing things you regret later. Controlling your drinks enables you to control your behaviour.</p>
                <h4>Alcohol and the Law</h4>
                <p>Alcohol impairs your judgement, which can lead to doing something you wouldn't when sober. Some alcohol-related laws to keep in mind are:</p>
                <ul>
                  <li>Consuming alcohol in a public place or on private property could result in a $500 fine and may even lead to a jail term of up to 60 days;</li>
                  <li>Argumentative, disorderly or violent behavior isn't acceptable, it can get you into trouble with the police.</li>
                </ul>
                </section>
            </ContentBox>
              </Content>  
              <Top style={{marginTop: "1.5%"}}>
          <ResponsesText>
          <p>PROCEED AHEAD TO CONTINUE WITH</p>
          <p> YOUR RESPONSES!</p>
        </ResponsesText>
          <img width={"100%"} src={Car} />
          </Top>  
                <ButtonWrap>
            {!isDownloading ? <Button onClick={onSectionChange}>Continue to Part 2 <img src={RightArrow} height={30} /></Button> : null}
          </ButtonWrap>  
      </ContentWrap>
      
      </BackgroundWrap>
      </MetricsWrap>
      
  );
};

const MetricsWrap = styled.article`
display: flex;
flex-direction: column;
/* background-color: #84aff6; */
/* background-image: url(${YouthBg});
background-size: cover;
      background-position: center;
      background-size: 650px 300px; */
    width: 100%; 
    @media only screen and (max-width: 550px) {
      background-size: unset;
      box-shadow: none;
    }
    /* .metrics-title{
      margin: auto;
    } */
    /* height: 100%;  */
`;

const ResponsesText = styled.div`
padding: 1%;
background: rgb(204,254,216);
background: linear-gradient(90deg, rgba(204,254,216,1) 0%, rgba(148,185,255,1) 100%);
border: 1px solid black;
color: #3e3e3e;
border-radius: 50px;
font-size: 40px;
font-weight: bold;
display: flex;
flex-direction: column;
justify-content: center;
p{
  align-self: center;
  margin: 0;
}

@media only screen and (max-width: 1024px) {
  font-size: 32px;
  padding: 2%;
}

@media only screen and (max-width: 768px) {
  font-size: 24px;
  padding: 2%;
  border-radius: 30px;
}

@media only screen and (max-width: 550px) {
  font-size: 18px;
  padding: 1.5%;
  border-radius: 25px;
}
`;

const VapeSectionWrap = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  @media (max-width: 1024px) {
    flex-direction: column;  /* ✅ stack vertically */
    align-items: center;
    justify-content: center;
    gap: 20px;
    width: 100%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding: 0 10px;
    width: 100%;
  }

  @media (max-width: 1024px) {
    display: none; /* hide on tablet and mobile, show only on desktop */
  }
`;

const MiniScreenWrap = styled.section`
display: none;
.quote{
  width: 50px;
  height: 50px;
}

@media only screen and (max-width: 1024px) {
  display: unset;
  padding: 0 15px;
  margin-bottom: 20px; /* Add gap between sections */
  width: 100%;
  
  .quote{
    width: 25px;
    height: 25px;
  }
}

@media only screen and (max-width: 768px) {
  display: unset;
  padding: 0 10px;
  margin-bottom: 20px; /* Add gap between sections */
  width: 100%;
  
  .quote{
    width: 20px;
    height: 20px;
  }
}

@media only screen and (max-width: 550px) {
  display: unset;
  padding: 0 5px;
  margin-bottom: 15px; /* Add gap between sections */
  width: 100%;
  
  .quote{
    width: 15px;
    height: 15px;
  }
  
  /* Add specific gap after heading text */
  > section:first-child {
    margin-bottom: 10px;
  }
}
`;

const ImagesWrap = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  img {
    margin-bottom: 2%;
    max-width: 100%;
    height: auto;
  }

  .tip-img {
    width: 100%;      /* scale to container */
    height: auto;     /* keep aspect ratio */
    object-fit: contain;
    background-color: #d3edff; /* ✅ blend with your blue box */
    display: block;            /* removes inline spacing gaps */
  }

  @media (max-width: 1024px) {
    img {
      max-width: 100%;
      height: auto;
    }
  }

  @media (max-width: 768px) {
    img {
      max-width: 100%;
      height: auto;
    }
  }

  @media (max-width: 550px) {
    img {
      max-width: 100%;
      height: auto;
    }
  }
`;



const AuditWrap = styled.section`
width: 75%;
display: flex;
flex-direction: column;
align-items: center;
/* border-right: solid 1px black; */
@media only screen and (max-width: 550px) {
  border: none;
  width: 100%;
}
@media only screen and (min-width: 550px) and (max-width: 1024px) {
        border: none;
    }
`;

const BACTipWrap = styled.section`
width: 45%;
/* margin-top: 40px; */
display: flex;
flex-direction: column;
align-items: center;
/* border-right: solid 1px black; */
    /* padding-right: 60px; */
/* position: relative; */
p{
    /* width: 60%;
    left: 82px;
    position: absolute;
    top: -85px;*/
    line-height: 1.4; 
}
@media only screen and (max-width: 550px) {
  width: 100%;
}
`;

const BingeTipSection = styled.section`
  position: relative;
  width: 42%;

  .binge-tip {
    width: 110%;
  }

  p {
    position: absolute;
    top: 120px;
    left: 120px;
    width: 45%;
    line-height: 1.5;
  }

  @media (max-width: 1024px) {
    width: 100%;            /* ✅ take full width */
    display: flex;
    justify-content: center;
    margin-top: 20px;

    .binge-tip {
      width: 80%;           /* ✅ scale gracefully */
    }

    p {
      position: static;      /* ✅ no absolute text overlap */
      width: 90%;
      text-align: center;
      margin-top: 10px;
    }
  }
`;


const ContentBox = styled.section`
background-color: #d3edff;
border-radius: 5px;
font-size: 20px;
padding: 3%;
margin: 1.5% 0 0;
.speech { 
  width: 250px; 
  background: green; 
  padding: 30px; 
  text-align: center; 
  font-size: 35px; 
  border-radius: 35px; 
  color: cyan; 
  position: relative; 
} 
h4{
  margin: 0;
}

/* Creates triangular tip on the 
   end, for our speech bubble  
   with some styling */ 
.speech:before { 
  content: ""; 
  position: absolute; 
  border-left: 20px solid green; 
  border-right: 20px solid transparent; 
  border-top: 20px solid green; 
  border-bottom: 20px solid transparent; 
  right: -20px; 
  top: 10px; 
} 
.quote{
  width: 35px;
  height: 35px;
}

@media only screen and (max-width: 1024px) {
  padding: 2.5%;
  margin: 1% 0 0;
  font-size: 18px;
  .quote{
    width: 25px;
    height: 25px;
  }
}

@media only screen and (max-width: 768px) {
  padding: 2%;
  margin: 1% 0 0;
  font-size: 16px;
  .quote{
    width: 20px;
    height: 20px;
  }
}

@media only screen and (max-width: 550px) {
  padding: 1.5%;
  margin: 0.5% 0 0;
  font-size: 14px;
  .quote{
    width: 15px;
    height: 15px;
  }
}
`;

const TipsHeading = styled.span`
background-color: #ffd42a;
border-radius: 10px;
padding: 10px;
font-size: 27px;
font-weight: bold;

@media only screen and (max-width: 1024px) {
  font-size: 22px;
  padding: 8px;
}

@media only screen and (max-width: 768px) {
  font-size: 18px;
  padding: 6px;
}

@media only screen and (max-width: 550px) {
  font-size: 14px;
  padding: 4px;
}
`;

const HeadingWrap = styled.section`
display: flex;
    justify-content: center;
    margin: 0 0 20px 0;
`;

const HeadingText = styled.div`
width: ${(props) => props.width ? props.width : 400}px;
background: rgb(204,254,216);
background: linear-gradient(90deg, rgba(204,254,216,1) 0%, rgba(148,185,255,1) 100%);
border: 1px solid black;
padding: 5px 20px;
color: #3e3e3e;
border-radius: 50px;
display: flex;
flex-direction: column;
justify-content: center;
margin-bottom: 20px;
h3{
  font-size: 35px;
}
h4{
  font-size: 20px;
}
h3, h4{
  align-self: center;
  margin: 5px 0;
}
.quote{
  width: 35px;
  height: 35px;
}

@media only screen and (max-width: 1024px) {
  width: ${(props) => props.width ? props.width : 300}px;
  margin-bottom: 15px;
  h3{
    font-size: 28px;
  }
  h4{
    font-size: 18px;
  }
}

@media only screen and (max-width: 768px) {
  width: ${(props) => props.width ? props.width : 250}px;
  padding: 4px 15px;
  margin-bottom: 12px;
  h3{
    font-size: 22px;
    margin: 3px 0;
  }
  h4{
    font-size: 16px;
    margin: 3px 0;
  }
}

@media only screen and (max-width: 550px) {
  width: ${(props) => props.width ? props.width : 90}%;
  padding: 3px 10px;
  margin-bottom: 10px;
  h3{
    font-size: 16px;
    margin: 2px 0;
  }
  h4{
    font-size: 12px;
    margin: 2px 0;
  }
}
`;

const DaysText = styled.span`
background-color: white;
border: 1px solid black;
padding: 3px;
border-radius: 25px;
font-size: 22px;
margin: 0 0 0 1.5%;

@media only screen and (max-width: 1024px) {
  font-size: 18px;
  padding: 2px 8px;
}

@media only screen and (max-width: 768px) {
  font-size: 16px;
  padding: 2px 6px;
  margin: 0 0 0 1%;
}

@media only screen and (max-width: 550px) {
  font-size: 14px;
  padding: 2px 5px;
  margin: 0 0 0 0.5%;
}
`;

const TobaccoTipWrap = styled.section`
position: relative;
.tobacco-tip{
  margin-top: 2%;
}
div{
      left: 130px;
    position: absolute;
    bottom: 82px;
    width: 80%;
    line-height: 1.4;
}
`;

// const BingeTip = styled.section`
// background-image: url(${BingeDrinkingTip});
// width: 100%;
// height: 100%;
// `;

const BackgroundWrap = styled.article`
width: 100%;
display: flex;
flex-direction: column;
/* background-color: white; */
background-image: url(${YouthBg});
background-size: cover;
      background-position: center;
      background-size: 650px 300px;
`;

const Heading = styled.section`
        display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    img{
      width: 150px;
      height: 60px;
    }
    h2{
      margin: 0;
    }
    @media only screen and (max-width: 550px) {
    font-size: 18px;
    margin: 10px 0 5px;
    img{
      width: 150px;
      height: 25px;
    }
    h2{
      font-size: 12px;
      margin-top: 5px !important;
    }
    }
    margin-bottom: 25px;
`;

const ContentWrap = styled.article`
  width: 85%;
  align-self: center;
  margin-bottom: 40px;
  position: relative;

  @media (max-width: 1024px) {
    width: 90%;
    margin-bottom: 30px;
  }

  @media (max-width: 768px) {
    width: 95%;
    margin-bottom: 20px;
  }

  @media (max-width: 550px) {
    width: 98%;
    margin-bottom: 15px;
  }

  &.force-desktop {
    width: 85% !important;

    /* override all mobile media queries */
    @media (max-width: 1024px) {
      width: 85% !important;
      font-size: 16px !important;
    }
    @media (max-width: 550px) {
      width: 85% !important;
      font-size: 16px !important;
    }
  }
`;

const BACScoreWrap = styled.section`
display: flex;
align-items: center;
justify-content: space-between;
border-bottom: solid 1.5px #4a4a4a30;
padding: 50px 0;
@media only screen and (max-width: 1024px) {
  justify-content: center;
  gap: 20px;
}
@media only screen and (max-width: 550px) {
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
}
`;

const AuditScoreWrap = styled.section`
display: flex;
align-items: center;
justify-content: space-between;
padding: 20px 0;
@media only screen and (max-width: 1024px) {
  justify-content: center;
  gap: 20px;
}
@media only screen and (max-width: 550px) {
  flex-direction: column;
  align-items: center;
}
`;

const Legend = styled.section`
width: 100%;
    margin-top: 30px;
display: flex;
justify-content: space-between;
/* flex-wrap: wrap; */
padding-bottom: 30px;
@media only screen and (max-width: 550px) {
       margin-top: 15px;
  padding-bottom: 5px;
}
`;

const AuditTypes = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 20px;
    .selected-text{
      h4{
      color: white !important;
      }
    }
    @media only screen and (max-width: 550px) {
      margin-right: unset;
    }
    @media only screen and (min-width: 550px) and (max-width: 1024px) {
      margin-right: 10px;
    }
`;

const Round = styled.span`
display: block;
width: 20px;
height: 20px;
background-color: #fafafa;
border: 4px solid #fafafa;
border-radius: 25px;
margin-bottom: 20px;
@media only screen and (max-width: 550px) {
  width: 8px;
  height: 8px;
    margin-bottom: 10px;
  /* border: 2px solid #fafafa; */
}
@media only screen and (min-width: 550px) and (max-width: 1024px) {
       width: 13px;
       height: 13px;
    }
`;

export const SmokeLabel = styled.span`
width: 95px;
text-align: right;
@media only screen and (max-width: 550px) {
  width: 45px;
  font-size: 10px !important;
}
`;

const AuditContent = styled.div`
/* margin: 50px 0; */
/* width: 50%; */
    text-align: center;
    display: flex;
    flex-direction: column;
color: #5e5e5e;
h3{
  font-size: 25px;
  font-weight: bold;
  margin: 0;
  line-height: 35px;
}
.auditScore{
  font-size: 40px;
  border-radius: 25px;
  background-color: white;
  border: 1px solid black;
  padding: 3px 30px;
    font-weight: bold;
  margin-top: 20px;
}
.categoryText{
  margin-top: 20px;
  @media only screen and (max-width: 550px) {
    margin-top: unset;
  }
}
.audit-score-wrap{
align-items: center;
margin-top: 20px;
@media only screen and (max-width: 550px) {
  margin-top: 3%;
}
}
h4{
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  line-height: 25px;
}
p{
  line-height: 30px;
}
@media only screen and (max-width: 550px) {
  width: 100%;
  h3, h4{
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  }
  p{
    font-size: 10px;
    line-height: 15px;
  }
  .auditScore{
    font-size: 16px;
  }
}
@media only screen and (min-width: 550px) and (max-width: 1024px) {
         h3{
          font-size: 20px;
          line-height: unset;
         }
         .auditScore{
          font-size: 35px;
         }
         p{
          line-height: 20px;
          margin: 0;
         }
    }
`;

const BACContent = styled.div`
text-align: center;
display: flex;
flex-direction: column;
color: #5e5e5e;
h2{
  margin: 0;
}
h3{
  font-size: 25px;
  font-weight: bold;
  margin: 10px 0 0;
}
h4{
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

@media only screen and (max-width: 1024px) {
  h2{
    font-size: 20px;
  }
  h3{
    font-size: 18px;
  }
  h4{
    font-size: 16px;
  }
}

@media only screen and (max-width: 768px) {
  h2{
    font-size: 16px;
  }
  h3{
    font-size: 14px;
  }
  h4{
    font-size: 14px;
  }
}

@media only screen and (max-width: 550px) {
  width: 100%;
  h2{
    font-size: 14px;
  }
  h3{
    font-size: 12px;
    margin: 1% 0 3%;
  }
  h4{
    font-size: 12px;
  }
  p{
    font-size: 10px;
  }
  .auditScore{
    font-size: 16px;
  }
}
`;

const BACWrap = styled.section`
display: flex;
align-items: center;
justify-content: center;
gap: 20px;
width: 100%;
overflow: hidden;

@media only screen and (max-width: 1024px) {
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 0 10px;
}

@media only screen and (max-width: 768px) {
  gap: 10px;
  padding: 0 15px;
}

@media only screen and (max-width: 550px) {
  padding: 0 20px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
`;

const Box = styled.section`
  background-color: white;
  padding: 20px;
  border-radius: 25px;
  border: 1px solid black;
  text-align: center;
  margin-right: 20px; 
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60%;
  max-width: 60%;
  overflow: hidden;

  h3 {
    margin: 15px 0 0;
    font-size: 18px;
  }

  @media only screen and (max-width: 1024px) {
    margin-right: unset;
    margin: 0 auto 20px auto;
    padding: 15px;
    width: 100%;
    max-width: 100%;
    margin-top: 20px; /* Add space above chart */
    overflow: hidden;
    h3 {
      font-size: 16px;
      margin: 15px 0 0;
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 12px;
    margin-top: 15px; /* Add space above chart */
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    h3 {
      font-size: 14px;
      margin: 12px 0 0;
    }
  }
`;


const AlcoholTipWrap = styled.section`
  width: 55%;
  position: relative;

  .alcohol-tip {
    width: 100%;
    margin-top: 3%;
  }

  p {
    position: absolute;
    top: 100px;
    left: 30px;
    width: 60%;
    line-height: 1.4;
  }

  @media (max-width: 1024px) {
    width: 100%;            /* ✅ expand full width */
    margin-top: 20px;
    text-align: center;

    .alcohol-tip {
      width: 80%;           /* ✅ scale inside container */
      margin: 20px auto 0;
    }

    p {
      position: static;      /* ✅ remove absolute positioning */
      width: 90%;
      margin: 10px auto 0;
    }
  }
`;


const DrinksTipWrap = styled.section`
  width: 48%;
  position: relative;

  .drink-tip {
    width: 100%;
  }

  p {
    width: 90%;
    line-height: 1.4;
  }

  @media (max-width: 1024px) {
    width: 100%;             /* ✅ full width */
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;

    .drink-tip {
      width: 75%;            /* ✅ scale down gracefully */
    }

    p {
      width: 90%;
      text-align: center;
      margin-top: 10px;
    }
  }
`;


const BarCompWrap = styled.div`
  width: ${props => props.width ? `${props.width}px` : '100%'};
  height: ${props => props.height ? `${props.height}px` : '250px'};
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @media (max-width: 1024px) {
    height: 220px;
    width: 100%;
    max-width: 100%;
    padding: 0 1%;
    overflow: hidden;
  }

  @media (max-width: 768px) {
    height: 200px;
    width: 100%;
    max-width: 100%;
    padding: 0;
    overflow: hidden;
  }

  @media (max-width: 550px) {
    height: 180px;
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin-bottom: 10px;
    overflow: hidden;
  }
`;

const BarCompHorizontalWrap = styled.div`
  width: ${props => props.width ? `${props.width}px` : '100%'};
  height: ${props => props.height ? `${props.height}px` : '250px'};
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1024px) {
    height: 220px;
    width: 100%;
    max-width: 100%;
    padding: 0 1%;
  }

  @media (max-width: 768px) {
    height: 200px;
    width: 100%;
    max-width: 100%;
    padding: 0;
  }

  @media (max-width: 550px) {
    height: 180px;
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin-bottom: 10px;
  }
`;


const BACChartWrap = styled.div`
  width: 100%;
  max-width: 450px;
  height: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 0 10px;

  @media (max-width: 1024px) {
    max-width: 380px;
    height: auto;
    min-height: 200px;
    padding: 0 15px;
  }

  @media (max-width: 768px) {
    max-width: 320px;
    min-height: 180px;
    padding: 0 20px;
  }

  @media (max-width: 550px) {
    max-width: 100%;
    min-height: 150px;
    margin-bottom: 20px;
    padding: 0 10px;
  }
`;


const PieChartWrap = styled.div`
width: 65%;
height: 350px;
margin: 0 auto;
display: flex;
justify-content: center;
align-items: center;

@media only screen and (max-width: 1024px) {
  width: 80%;
  height: 280px;
}

@media only screen and (max-width: 768px) {
  width: 90%;
  height: 220px;
}

@media only screen and (max-width: 550px) {
  width: 95%;
  height: 200px;
  margin-bottom: 20px;
}
`;

const AlcoholContent = styled.div`
margin: 0 50px;
color: #5e5e5e;
h3{
  font-size: 30px;
  font-weight: bold;
  margin: 0;
  line-height: 35px;
}
@media only screen and (max-width: 550px) {
  margin: 0;
h3, h2{
    font-size: 12px;
    line-height: 15px;
  }
  p{
    font-size: 10px;
    line-height: 15px;
  }
}
`;

const BelowAvgTextWrap = styled.section`
display: flex;
flex-direction: column;
width: 100%;
align-items: center;
h2{
  margin: 0;
}
`;

const Percentage = styled.span`
  font-size: 30px;
  color: #025DC7;
`;

const RectangleAuditBox = styled.div`
width: 110px;
height: 110px;
border-radius: 5px;
background-color: #fafafa;
display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    h4{
      margin: 0;
    }
    .audit-number{
      font-size: 28px;
    }
    .audit-text{
      font-size: 20px;
      color: #919191;
    }
    @media only screen and (max-width: 550px) {
      width: 70px;
      height: 70px;
      margin-bottom: 5%;
      .audit-number{
      font-size: 20px;
    }
    .audit-text{
      font-size: 13px;
    }
    }  
    @media only screen and (min-width: 550px) and (max-width: 1024px) {
        width: 80px;
        height: 80px;
        .audit-number{
          font-size: 22px;
        }
        .audit-text{
          font-size: 16px;
        }
    }  
`;



const BarWrap = styled.div`
display: flex;
align-items: center;
font-weight: bold;
color: #5e5e5e;
`;

const ButtonWrap = styled(BaseButtonWrap)`
    bottom: -90px;
    right: 0px;
    button{
         margin-bottom: 30px;
    }
`;

const BACPopData = styled.section`
display: flex;
width: 100%;
justify-content: center;
align-items: center;
gap: 40px;
img{
  margin-bottom: 10px;
}

@media only screen and (max-width: 1024px) {
  gap: 30px;
}

@media only screen and (max-width: 768px) {
  gap: 20px;
}

@media only screen and (max-width: 550px) {
  gap: 15px;
}
`;

const DonutChartWrap = styled.div`
width: 100%;
height: 350px;
@media only screen and (max-width: 550px) {
  height: 200px;
}
`;

const MaleData = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
text-align: center;
p{
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  >span:first-of-type{
    font-size: 10px;
    font-weight: bold;
  }
  >span:last-of-type{
    font-size: 12px;
    color: #f1646c;
  }
}

@media only screen and (max-width: 1024px) {
  img{
    width: 60%;
  }
}

@media only screen and (max-width: 768px) {
  img{
    width: 65%;
  }
}

@media only screen and (max-width: 550px) {
  img{
    width: 70%;
  }
  p{
    font-size: 10px;
    gap: 1px;
    >span:first-of-type{
      font-size: 8px;
    }
    >span:last-of-type{
      font-size: 10px;
    }
  }
}
`;

const FemaleData = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
text-align: center;
p{
  margin:0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  >span:first-of-type{
    font-size: 10px;
    font-weight: bold;
  }
  >span:last-of-type{
    font-size: 12px;
    color: #f1646c;
  }
}

@media only screen and (max-width: 1024px) {
  img{
    width: 60%;
  }
}

@media only screen and (max-width: 768px) {
  img{
    width: 65%;
  }
}

@media only screen and (max-width: 550px) {
  img{
    width: 70%;
  }
  p{
    font-size: 10px;
    gap: 1px;
    >span:first-of-type{
      font-size: 8px;
    }
    >span:last-of-type{
      font-size: 10px;
    }
  }
}
`;

const PDFSpacer = styled.div`
  height: ${(props) => props.height || '40px'};
  @media screen {
    display: none;
  }
`;

export const DownloadOverrides = createGlobalStyle`
  body.force-desktop * {
    /* Pretend screen is always large */
    @media (max-width: 1024px) {
      all: unset !important;
    }
    @media (max-width: 768px) {
      all: unset !important;
    }
    @media (max-width: 550px) {
      all: unset !important;
    }
  }

  /* optional: reset specific elements */
  body.force-desktop .MiniScreenWrap {
    display: none !important;
  }
  body.force-desktop .VapeSectionWrap {
    display: flex !important;
  }
  
`;



const PopData = styled.div`
display: flex;
flex-direction: column;
align-items: center;
`;

const Top = styled.section`
background-color: #d3edff;
color: white;
padding: 2% 0 0;
display: flex;
flex-direction: column;
align-items: center;
img{
  margin-top: 1%;
  max-width: 100%;
  height: auto;
}

@media only screen and (max-width: 1024px) {
  padding: 1.5% 0 0;
}

@media only screen and (max-width: 768px) {
  padding: 1% 0 0;
  img{
    margin-top: 0.5%;
  }
}

@media only screen and (max-width: 550px) {
  padding: 0.5% 0 0;
  h3{
    font-size: 12px !important;
  }
  p{
    font-size: 14px !important;
  }
  img{
    margin-top: 0.25%;
  }
}
`;
const Content = styled.section`
padding: 0;

@media only screen and (max-width: 1024px) {
  padding: 0 5px;
}

@media only screen and (max-width: 768px) {
  padding: 0 10px;
}

@media only screen and (max-width: 550px) {
  padding: 0 5px;
}
`;


export default MIMetrics1;